import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Spinner,
} from '@crm/ui';
import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router-dom';
import { FormError, FormField, FormSuccess } from '@/components';
import { useDocumentTitle } from '@/hooks';
import { AUTH_ROUTES } from '../constants';
import { useForgotPassword } from '../hooks';
import { type ForgotPasswordFormValues, forgotPasswordSchema } from '../schemas';
import { toErrorMessage } from '../utils';

export function ForgotPasswordPage() {
  useDocumentTitle('Recuperar senha');

  const forgotPassword = useForgotPassword();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordFormValues>({
    resolver: zodResolver(forgotPasswordSchema),
    defaultValues: { email: '' },
  });

  return (
    <Card className="w-full max-w-md">
      <CardHeader>
        <CardTitle className="text-xl">Recuperar senha</CardTitle>
        <CardDescription>
          Informe o e-mail da conta e enviaremos um link para criar uma nova senha.
        </CardDescription>
      </CardHeader>
      <CardContent>
        {forgotPassword.isSuccess ? (
          <div className="space-y-4">
            <FormSuccess message={forgotPassword.data.message} />
            <p className="text-xs text-muted-foreground">
              Em desenvolvimento nao ha envio de e-mail: o link aparece no log do worker.
            </p>
            <Button variant="outline" className="w-full" asChild>
              <Link to={AUTH_ROUTES.LOGIN}>Voltar para o login</Link>
            </Button>
          </div>
        ) : (
          <form
            className="space-y-4"
            onSubmit={handleSubmit((values) => forgotPassword.mutate(values.email))}
            noValidate
          >
            <FormError
              message={forgotPassword.error ? toErrorMessage(forgotPassword.error) : null}
            />

            <FormField
              label="E-mail"
              type="email"
              autoComplete="email"
              placeholder="voce@empresa.com"
              error={errors.email?.message}
              {...register('email')}
            />

            <Button type="submit" className="w-full" disabled={forgotPassword.isPending}>
              {forgotPassword.isPending ? <Spinner /> : null}
              Enviar link
            </Button>

            <p className="text-center text-sm text-muted-foreground">
              <Link to={AUTH_ROUTES.LOGIN} className="font-medium text-primary hover:underline">
                Voltar para o login
              </Link>
            </p>
          </form>
        )}
      </CardContent>
    </Card>
  );
}
